import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$6 } from './p-BedvZv52.js';
import { d as defineCustomElement$5 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$4 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$3 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$2 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$1 } from './p-QtR5VUMp.js';

const moreMenuCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;position:relative;width:-webkit-min-content;width:min-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}wui-list{max-width:240px;min-width:120px}";

const WuiMoreMenu = /*@__PURE__*/ proxyCustomElement(class WuiMoreMenu extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.openChanged = createEvent(this, "openChanged", 3);
        /**
         * Positioning for the icon within the button.
         *
         */
        this.iconPosition = 'leading';
        /**
         * Disable button
         */
        this.disabled = false;
        /**
         * Display loading state on button
         */
        this.loading = false;
        /**
         * Close menu when clicking inside of it (eg. on a list-item)
         */
        this.closeOnClickInside = false;
        /**
         * If menu pane opened
         */
        this.open = false;
        this.toggleMenu = (open = !this.open) => {
            if (open === this.open) {
                return;
            }
            this.open = open;
            this.openChanged.emit(this.open);
        };
    }
    render() {
        const type = this.buttonType || (this.icon && this.label ? 'tertiary' : this.icon ? 'icon' : 'primary');
        return (h(Host, { key: '8d2a81cad3df9200e84b671c9b59d215d3c30c82', role: "button", disabled: this.disabled }, h("wui-button", { key: '774adb50acf03f6a43e062dcb6df5e3a0b347b97', icon: this.icon, label: this.label, tooltip: this.tooltip, type: type, iconPosition: this.iconPosition, disabled: this.disabled, loading: this.loading, onClick: () => {
                this.toggleMenu();
            } }), h("wui-menu-pane", { key: '68dde2b9fe789346a25b418d5d2e9c4059591205', ...this.menuPane, open: this.open, onClick: (e) => {
                if (!this.closeOnClickInside) {
                    return;
                }
                const target = e.target;
                if (target.className.startsWith('wui-menu-pane')) {
                    return;
                }
                this.toggleMenu(false);
            }, onClickOutside: () => {
                this.toggleMenu(false);
            }, onOpenChanged: (e) => {
                this.toggleMenu(e.detail);
            } }, h("slot", { key: '472f6bde5ee2e63b00d2c3f70440b0cad12f53be' }))));
    }
    static get style() { return moreMenuCss; }
}, [257, "wui-more-menu", {
        "label": [1],
        "icon": [1],
        "iconPosition": [1, "icon-position"],
        "buttonType": [1, "button-type"],
        "tooltip": [1],
        "disabled": [516],
        "loading": [516],
        "closeOnClickInside": [4, "close-on-click-inside"],
        "menuPane": [16, "menu-pane"],
        "open": [1540]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-more-menu", "wui-button", "wui-icon", "wui-loader", "wui-menu-pane", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiMoreMenu);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiMoreMenu as W, defineCustomElement as d };
